import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { NavigationModalComponent } from './navigation-modal.component';
import { CommonModule } from '@angular/common';
import { SigninModule } from 'src/app/auth/signin/signin.module';
import { LoginModule } from 'src/app/auth/login/login.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SponsorsLoginModule } from 'src/app/sponsors/sponsors-login/sponsors-login.module';

@NgModule({
    declarations: [
        NavigationModalComponent
    ], 
    imports: [
        CommonModule, 
        SigninModule, 
        LoginModule, 
        FormsModule, 
        ReactiveFormsModule, 
        SponsorsLoginModule
    ], 
    exports: [
        NavigationModalComponent
    ], 
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, 
        NO_ERRORS_SCHEMA
    ]
})
export class NavigationModalModule {}